import { render, staticRenderFns } from "./CharacterProperties.vue?vue&type=template&id=2995d5d4&scoped=true"
import script from "./CharacterProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./CharacterProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CharacterProperties.vue?vue&type=style&index=0&id=2995d5d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2995d5d4",
  null
  
)

export default component.exports